<div class="text-header"></div>

<app-grid>
    <app-cell mobile="0:12" tablet="full:full">
        <div class="header-container">
            <div class="icon-container">
                <span [appIcon]="icon"></span>
            </div>

            <div class="message-content">
                <h2>
                    {{ title }}
                </h2>

                <p>
                    {{ subtitle }}
                </p>
            </div>
        </div>
    </app-cell>
</app-grid>
